<header class="event">
	<div class="row" *ngIf="logo && type == 'page'">
		<!-- logo -->
		<div class="columns small-12" [class.text-center]="logoCentered">
			<img [src]="logo" [alt]="" class="logo">
		</div>
	</div>

	<div class="row collapse">
		<div class="small-12 columns">
			<!-- headline -->
			<h1>{{ eventName }}</h1>
		</div>

		<div class="small-12 columns image-wrapper" *ngIf="image || youtubeUrl" [class.ended]="donationFormHidden">
			<img [src]="image" alt="{{ eventName }}" class="image" *ngIf="!youtubeUrl">
			<iframe *ngIf="youtubeUrl" width="768" height="432" [src]="youtubeUrl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			<span class="hint" *ngIf="donationFormHidden" [innerHTML]="'event.detail.end.hint' | translate"></span>
		</div>
	</div>

	<div class="row">
		<div class="columns small-12">
			<!-- Progess bar -->
			<project-progress [size]="size"></project-progress>

			<span class="endsat" *ngIf="endDays != null" [innerHTML]="'event.detail.end.date' | translate: {'days': endDays}"></span>

			<!-- Teaser -->
			<p class="teaser nl2br" *ngIf="teaser">
				{{ teaser }}
			</p>
		</div>
	</div>

	<div class="row column" *ngIf="donationFormHidden">
		<div class="callout">
			<p [innerHTML]="'event.detail.end' | translate"></p>
			<a *ngIf="endUrl" [href]="endUrl" class="button primary" target="_blank" [innerHTML]="'event.detail.end.button' | translate"></a>
		</div>
	</div>
</header>
